<template>
  <div class="calculator-background" @click.self="$emit('close')">
    <div class="modal">
      <div class="investment-section">
        <div class="modal-header">
          Calcula tus ganancias
        </div>
        <label class="label">
          ¿Cuánto te gustaría invertir?
          <div class="input-wrapper">
            $<input
              v-bind:value="stylizeNumber(value)"
              v-on:input="value = $event.target.value.replace(/,/g, '')"
              class="input">
            <div class="input-error" v-show="!validateValue">
              Tu inversión debe ser mayor a $10,000
            </div>
          </div>
        </label>
        <div class="section" style="margin-top: 10px;">
          <div class="section-title">
            Proyección pesimista
            <div class="tir"><div class="tir-tag">TIR</div>{{ formatPercentage(project.pessimistIrr) }}%</div>
          </div>
          <div class="investment-item">
            <div>
              Recuperación de la inversión
              <!-- Cuanto tiempo vas a tardar en recuperar tu dinero -->
            </div>
            3 años 7 meses
          </div>
          <div class="investment-item">
            <div>
              Retorno al finalizar el periodo
              <!-- Cuanto dinero vas a tener despues de 5 años -->
            </div>
            <div v-if="value">{{ formatMoney(pessimistic * 100) }}</div>
          </div>
        </div>
        <div class="section">
          <div class="section-title">
            Proyección conservadora
            <div class="tir"><div class="tir-tag">TIR</div>{{ formatPercentage(project.conservativeIrr) }}%</div>
          </div>
          <div class="investment-item">
            <div>
              Recuperación de la inversión
            </div>
            2 años 11 meses
          </div>
          <div class="investment-item">
            <div>
              Retorno al finalizar el periodo
            </div>
            <div v-if="value">{{ formatMoney(conservative * 100) }}</div>
          </div>
        </div>
        <div class="section">
          <div class="section-title">
            Proyección optimista
            <div class="tir"><div class="tir-tag">TIR</div>{{ formatPercentage(project.optimisticIrr) }}%</div>
          </div>
          <div class="investment-item">
            <div>
              Recuperación de la inversión
            </div>
            2 años 4 meses
          </div>
          <div class="investment-item">
            <div>
              Retorno al finalizar el periodo
            </div>
            <div v-if="value">{{ formatMoney(optimistic * 100) }}</div>
          </div>
        </div>
        <div class="invest-section">
          ¿Estás listo para volverte socio?
          <div class="button" @click="$router.push('/register')" v-if="!user" v-show="value && validateValue">
            Invertir
          </div>
          <div class="button" @click="$emit('close')" v-else v-show="value && validateValue">
            Invertir
          </div>
        </div>
      </div>
      <div class="results-section">
        <div class="selector-container">
          <div class="chart-selector">
            <div class="chart-option selected-option">
              Retorno de inversión
            </div>
            <div class="divisor"></div>
            <div class="chart-option">
              Competencia
            </div>
          </div>
        </div>
        <div class="chart-wrapper">
          <div class="chart-container">
            <canvas id="investment-chart" width="300" height="200"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import Chart from 'chart.js';
import formatMixin from '@/mixins/formatMixin';
import { mapMutations } from 'vuex';

export default {
  data() {
    return {
      value: null,
      optimistic: null,
      pessimistic: null,
      conservative: null,
    };
  },
  mixins: [formatMixin],
  props: {
    project: Object,
  },
  watch: {
    value() {
      this.createChart();
    },
  },
  computed: {
    validateValue() {
      if (this.value && this.value < 10000) {
        return false;
      }
      return true;
    },
    user() {
      return this.$store.state.user.user;
    },
  },
  methods: {
    stylizeNumber(number) {
      if (number !== null) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      return null;
    },
    createChart() {
      document.getElementById('investment-chart').innerHTML = '&nbsp;';
      document.getElementById('investment-chart').innerHTML = '<canvas id="myCalculator"></canvas>';
      const newCalc = document.getElementById('investment-chart').getContext('2d');
      let optimisticArray = [];
      let conservativeArray = [];
      let pessimisticArray = [];
      let total = 0;

      if (this.project.id === 4) {
        optimisticArray = [0, 3960000, 4078800, 4201164, 4327199, 4457015];
        conservativeArray = [0, 3600000, 3708000, 3819240, 3933817, 4051832];
        pessimisticArray = [0, 2736000, 2818080, 2902622, 2989701, 3079392];
        total = 30000000;
      } else if (this.project.id === 5) {
        optimisticArray = [0, 7200000, 7416000, 7638480, 7867634, 8103663, 8346773, 8597177, 8855092];
        conservativeArray = [0, 6480000, 6674400, 6874632, 7080871, 7293297, 7512096, 7737459, 7969538];
        pessimisticArray = [0, 5040000, 5191200, 5346936, 5507344, 5672564, 5842741, 6018024, 6198564];
        total = 30000000;
      } else { // Amorino
        optimisticArray = [0, 2600000, 2860000, 3088800, 3243240, 3405402];
        conservativeArray = [0, 2000000, 2200000, 2376000, 2494800, 2619540];
        pessimisticArray = [0, 1600000, 1760000, 1900800, 1995840, 2095632];
        total = 6500000;
      }

      const labels = Array.from({ length: optimisticArray.length }, (v, k) => k);
      const valueInvestment = this.value ? Number(this.value) : 6500000;
      const investmentArray = Array.from({ length: optimisticArray.length }, () => valueInvestment);
      // const optimisticValue = (100 * ((1 + (this.optimisticForecast / 100)) ** 5)) / 5;
      // const conservativeValue = (100 * ((1 + (this.conservativeForecast / 100)) ** 5)) / 5;
      // const pessimisticValue = (100 * ((1 + (this.pessimisticForecast / 100)) ** 5)) / 5;
      const percentageInvestment = valueInvestment / total;

      for (let i = 1; i < optimisticArray.length; i += 1) {
        optimisticArray[i] = (optimisticArray[i] * percentageInvestment) + optimisticArray[i - 1];
        conservativeArray[i] = (conservativeArray[i] * percentageInvestment) + conservativeArray[i - 1];
        pessimisticArray[i] = (pessimisticArray[i] * percentageInvestment) + pessimisticArray[i - 1];
      }
      this.optimistic = optimisticArray[optimisticArray.length - 1];
      this.conservative = conservativeArray[conservativeArray.length - 1];
      this.pessimistic = pessimisticArray[pessimisticArray.length - 1];
      // eslint-disable-next-line
      const myChart = new Chart(newCalc, {
        plugins: [],
        type: 'line',
        data: {
          labels,
          datasets: [
            {
              label: 'Optimista',
              data: optimisticArray,
              borderColor: '#0cbf9c',
              pointBackgroundColor: '#0cbf9c',
              backgroundColor: 'rgba(255, 255, 255, 0)',
              borderWidth: 2,
              pointRadius: 0,
            },
            {
              label: 'Conservador',
              data: conservativeArray,
              borderColor: '#fcbf29',
              pointBackgroundColor: '#fcbf29',
              backgroundColor: 'rgba(255, 255, 255, 0)',
              borderWidth: 2,
              pointRadius: 0,
            },
            {
              label: 'Pesimista',
              data: pessimisticArray,
              borderColor: '#f82630',
              pointBackgroundColor: '#f82630',
              backgroundColor: 'rgba(255, 255, 255, 0)',
              borderWidth: 2,
              pointRadius: 0,
            },
            {
              label: 'Inversión inicial',
              data: investmentArray,
              borderColor: 'rgba(0, 0, 0, 0.2)',
              backgroundColor: 'rgba(0, 0, 0, 0.01)',
              borderWidth: 1,
              pointRadius: 0,
            },
          ],
        },
        options: {
          legend: {
            display: false,
          },
          scales: {
            yAxes: [{
              ticks: {
                beginAtZero: true,
                callback: value => `$${value / 1000}k`,
              },
              gridLines: {
                display: false,
              },
            }],
            xAxes: [{
              scaleLabel: {
                display: true,
                labelString: 'años',
              },
              gridLines: {
                display: false,
              },
            }],
          },
          plugins: {
            // Change options for ALL labels of THIS CHART
            datalabels: {
              display: false,
            },
          },
        },
      });
    },
    ...mapMutations('investment', [
      'setCurrentProject',
      'setInvestment',
    ]),
  },
  mounted() {
    Chart.defaults.global.defaultFontFamily = 'Roboto';
    Chart.defaults.global.defaultFontSize = 14;
    this.createChart();
  },
};
</script>

<style lang="scss" scoped>
.calculator-background {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  padding-top: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.438);
}
.modal {
  width: 90%;
  height: fit-content;
  max-height: 90%;
  overflow-y: scroll;
  border-radius: 10px;
  display: flex;
  background-color: #f6f6f6;
}
.investment-section {
  background-color: white;
  padding: 30px;
  width: 50%;
  max-width: 50%;
  height: 100%;
}
.results-section {
  padding: 30px;
  width: 50%;
  max-width: 50%;
  height: 100%;
  border-radius: 0 10px 10px 0;
}
.modal-header {
  font-size: 32px;
  margin-bottom: 30px;
  font-weight: 500;
}
.input {
  border: 1px solid #DCDEDD;
  width: 50%;
  font-size: 16px;
  padding: 8px;
  margin-top: 16px;
  margin-left: 8px;
}
.label {
  display: flex;
  flex-direction: column;
  font-size: 18px;
}
.section {
  width: 100%;
  padding-top: 18px;
}
.section-title {
  font-size: 20px;
  margin-bottom: 14px;
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.investment-item {
  margin-top: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #DCDEDD;
  padding-bottom: 10px;
}
.selector-container {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px 0;
}
.chart-selector {
  width: 70%;
  display: flex;
  border: 1px solid #DCDEDD;

  .divisor {
    border-left: 1px solid #2c70c1;
  }
}
.chart-option {
  width: 50%;
  display: flex;
  padding: 10px 0;
  justify-content: center;
  color: rgb(156, 156, 156);
}
.chart-wrapper {
  width: 100%;
  padding: 30px 0;
  display: flex;
  justify-content: center;
}
.chart-container {
  width: 90%;
}
.selected-option {
  background-color: #2c70c1;
  color: white;
}
.invest-section {
  margin-top: 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  height: 37px;
}
.button {
  font-size: 15px;
  padding: 11px;
  width: 20%;
  text-align: center;
  background-color: #2c70c1;
  color: white;
  cursor: pointer;
}
.input-wrapper {
  display: flex;
  align-items: baseline;
}
.input-error {
  font-size: 14px;
  color: red;
  margin-left: 20px;
}
.tir {
  display: flex;
  align-items: center;
}
.tir-tag {
  font-size: 12px;
  padding: 5px 12px;
  border-radius: 100px;
  margin-right: 8px;
  background-color: #f6f6f6;
}
@media only screen and (max-width: 1050px) {
  .investment-section {
    width: 100%;
    max-width: 100%;
  }
  .results-section {
    display: none;
  }
}
@media only screen and (max-width: 480px) {
  .investment-item {
    flex-direction: column;
  }
}
@media only screen and (max-width: 400px) {
  .modal-header {
    font-size: 20px;
  }
  .label {
    font-size: 16px;
  }
  .section-title {
    font-size: 18px;
  }
  .section {
    margin-top: 16px;
  }
  .input-wrapper {
    display: flex;
    flex-wrap: wrap;
  }
  .input {
    width: 80%;
  }
  .input-error {
    margin-left: 0;
    margin-top: 14px;
  }
}
</style>
